module.exports = __webpack_public_path__ + "img/student.0b8b12f4.png";